import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage, useLocalizedHistory, I18nLangsLabels } from "../../../i18n";
import { RadioButton, RadioButtonGroup } from '../../Controls';

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      customHandleLangChange = _ref.customHandleLangChange;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang,
      allLangs = _useLanguage.allLangs;

  if (allLangs.length < 2) {
    return null;
  }

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var history = useLocalizedHistory();

  var handleChangeLang = function handleChangeLang(code) {
    history.push(pathname.replace("/\\/[".concat(allLangs.join('|'), "]/"), "/".concat(code)));
  };

  return /*#__PURE__*/React.createElement(RadioButtonGroup, {
    onChange: customHandleLangChange || handleChangeLang,
    value: currentLang,
    isCompact: true
  }, allLangs.map(function (code) {
    return /*#__PURE__*/React.createElement(RadioButton, {
      key: code,
      id: code,
      name: "lang-selector",
      value: code,
      label: isMobile ? I18nLangsLabels[code].labelFull : I18nLangsLabels[code].labelShort,
      size: "small"
    });
  }));
};

export default LanguageSwitcher;